import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

const EzugiGames = () => {
  const [isSidebar, setSidebar] = useState(false);
  const AllEzugiGames = [
    {
      src: "/Ezugi/348179.jpg",
      name: "32 Cards",
      provider: "vking",
      tableCode: "ez_32cd",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    {
      src: "/Ezugi/348191.jpg",
      name: "Andar Bahar",
      provider: "vking",
      tableCode: "ez_ab",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    {
      src: "/Ezugi/348201.jpg",
      name: "Bet On Numbers",
      provider: "vking",
      tableCode: "ez_bon",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348206.jpg",
    //   name: "Bet On TeenPatti",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348209.jpg",
      name: "BlackJack",
      provider: "vking",
      tableCode: "ez_bj",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348218.jpg",
    //   name: "Salon Prive",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348221.jpg",
    //   name: "Vip with Surrender Blackjack",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348224.jpg",
      name: "Casino Hold'em",
      provider: "vking",
      tableCode: "ez_chom",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    {
      src: "/Ezugi/348229.jpg",
      name: "Cricket War",
      provider: "vking",
      tableCode: "ez_cwar",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348238.jpg",
    //   name: "Dream Catcher",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348243.jpg",
    //   name: "EZ Dealer Roulette",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348246.jpg",
    //   name: "Golden Balls",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348249.jpg",
      name: "7 Lucky",
      provider: "vking",
      tableCode: "ez_lky7",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348251.jpg",
    //   name: "One Day Teen Patti Classic",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348259.jpg",
    //   name: "Royal Poker",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348262.jpg",
      name: "Sic Bo",
      provider: "vking",
      tableCode: "ez_sicb",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348269.jpg",
    //   name: "Ultimate Sic Bo",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348274.jpg",
    //   name: "Ultimate Andar Bahar",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348277.jpg",
      name: "Unlimited Blackjack",
      provider: "vking",
      tableCode: "ez_unbj",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348869.png",
    //   name: "Diamond Roulette",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348886.jpg",
    //   name: "Speed Cricket Baccarat",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/348902.png",
      name: "Teen Patti",
      provider: "vking",
      tableCode: "ez_botp",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/348907.png",
    //   name: "Ultimate Roulette",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    // {
    //   src: "/Ezugi/348916.png",
    //   name: "Video Jacker",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/423878.png",
      name: "Baccarat",
      provider: "vking",
      tableCode: "ez_bac",
      endpoint:"ezugi-games",
      tpGameId:601
    },
    {
      src: "/Ezugi/423883.png",
      name: "No Commission Baccarat",
      provider: "vking",
      tableCode: "ez_ncbac",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/423886.png",
    //   name: "Knockout Baccarat",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
    {
      src: "/Ezugi/423892.png",
      name: "Super 6 Baccarat",
      provider: "vking",
      tableCode: "ez_bacs6",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    {
      src: "/Ezugi/423899.png",
      name: "Dragon Tiger",
      provider: "vking",
      tableCode: "ez_dt",
      tpGameId:601,
      endpoint:"ezugi-games",
    },
    // {
    //   src: "/Ezugi/423904.png",
    //   name: "Speed Fortune Baccarat",
    //   provider: "vking",
    //   tableCode: "EVO_XLigRou",
    //   tpGameId:601
    // },
  ];

  useEffect(() => {
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Ezugi Games</span>{" "}
                    <span className="all">See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={AllEzugiGames} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default EzugiGames;
